import actionTypes from '../../actionTypes';

const states = {
    setActive: () => { },
    isModalActive: false,
    src: "",
    alt: ""
}

const GuideReducer = (state = states, action) => {
    const { type, payload } = action
    switch (type) {
        case actionTypes.active:
            return {
                ...state,
                setActive: payload
            }
        case actionTypes.toggleModal:
            return {
                ...state,
                isModalActive: payload
            }
        case actionTypes.setSrc:
            return {
                ...state,
                src: payload
            }
        case actionTypes.setAlt:
            return {
                ...state,
                alt: payload
            }
        default:
            return state
    }
}

export default GuideReducer